import * as SeparatorPrimitive from '@radix-ui/react-separator';

import cn from '../../utils/cn';

export type DividerProps = SeparatorPrimitive.SeparatorProps;

const Divider = ({ className, orientation = 'horizontal', decorative = true, ...props }: DividerProps) => (
  <SeparatorPrimitive.Root
    data-testid='divider'
    decorative={decorative}
    orientation={orientation}
    className={cn('bg-border shrink-0 bg-gray-light', orientation === 'horizontal' ? 'h-px w-full' : 'h-full w-px', className)}
    {...props}
  />
);

Divider.displayName = SeparatorPrimitive.Root.displayName;

export default Divider;
